import { render, staticRenderFns } from "./NoticeTicker.vue?vue&type=template&id=7d45c3da"
import script from "./NoticeTicker.ts?vue&type=script&lang=js&external"
export * from "./NoticeTicker.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports